import request from "@/utils/request.js";
// 登录api
export const login = data => {
  return request({
    method: "post",
    url: "/login",
    data
  });
};

// 修改密码
export const modifypassword = data => {
  return request({
    method: "post",
    url: "/user/modifypass",
    data
  });
};

// 退出登录
export const logout = () => {
  return request({
    method: "get",
    url: "/logout"
  });
};

// 获取用户可创建项目数量
export const getUserPower = () => {
  return request({
    method: "get",
    url: "/user/power"
  });
};
